<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            dataValueAppend="%"
            :color="color"
            :icons="icons"
            :title="title"
            :load_url="load_url">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard.vue';
    export default {
        name: 'CallsPerCampaignPenitration',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            var labels = [];
            for(var i = 8; i <= 17;i++){
                labels[i-8] = 'Hour '+i;
            }
            return {
                icons:labels,
                chart_type: 'bar',
                color: 'rgba(42, 157, 143, .6)',
                title: 'Campaign Penetration Percent',
                load_url: '/dashboards/CallsPerCampaignPenitration',
                time_wait: 10000,
                chart_layout: [
                    {
                        'label': 'Calls per Campaign Penetration',
                        'backgroundColor': 'rgb(0,0,158)', //can be an array for other graph types
                        'borderColor': '#00b',
                        'pointBackgroundColor': 'rgba(220, 220, 220, 0)',
                        'pointBorderColor': '#fff',
                        'pointHighlightFill': 'rgba(220, 220, 220, 0)',
                        'pointHighlightStroke': 'rgba(220, 220, 220, 0)',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>